import { useEffect } from 'react';
import './Preloader.css';

const Preloader = ({ isLoading }) => {
    useEffect(() => {
        if (isLoading) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
    }, [isLoading]);

    return (
        <div className={`preloader ${!isLoading ? 'preloader--hidden' : ''}`}>
            <div className="preloader__bg"></div>
            <div className="preloader__content">
                <div className="preloader__crest">
                    <div className="preloader__ring preloader__ring--outer"></div>
                    <div className="preloader__ring preloader__ring--inner"></div>
                    <div className="preloader__crescent">☽</div>
                    <div className="preloader__star">✦</div>
                </div>
                <div className="preloader__sword">
                    <div className="preloader__blade"></div>
                    <div className="preloader__guard"></div>
                    <div className="preloader__handle"></div>
                </div>
                <h1 className="preloader__title">صلاح الدين</h1>
                <p className="preloader__subtitle">Salah Eldin El-Ayoubi</p>
                <div className="preloader__bar">
                    <div className="preloader__bar-fill"></div>
                </div>
                <p className="preloader__tagline">Sultan of Egypt &amp; Syria · Liberator of Jerusalem</p>
            </div>
        </div>
    );
};

export default Preloader;
